<template>
  <div @click="goBonus" v-if="isShow" class="box">
    <div class="left">分红送配</div>
    <div class="right">
      <div  class="content">{{bonusInfo}}</div>
      <img class="right-arrow" src="https://j5.dfcfw.com/sc/image/202305/20230529052234.png"/>
    </div>
  </div>
</template>

<script>
import tool from '@/utils/tool';

export default {
  props: {
    fundCode: String, // 基金代码
    elementData: Object, // 数据
    mergeData: Object,
    anchorIndex: Number, // 锚点索引
  },

  data() {
    return {
      date: '',
      content: '',
    };
  },
  computed: {
    // 基金名
    fundName() {
      return this.elementData?.fundName;
    },

    isShow() {
      console.log('====> bouns mounted', this.mergeData);
      return this.mergeData?.bonusInfo?.date && this.mergeData?.bonusInfo?.content;
    },

    bonusInfo() {
      const { date, content } = this.mergeData?.bonusInfo || {};
      return `${date.substr(5)}每份派现金${parseFloat(content).toFixed(4)}元`;
    },
  },

  methods: {
    // 跳转到分红送配
    goBonus() {
      tool.goDetail(`fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/gdlcIndex/index?fundCode=${this.fundCode}&fundName=${this.fundName}&index=2`, this.$goFundApp);
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  margin-top: 24px;
  border-radius: 16px;
  background-color: #ffffff;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;
  padding-bottom: 24px;
}

.left {
  margin-left: 24px;
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #000000;
  font-weight: bold;
}

.right {

  display: flex;
  margin-right: 14px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.content {
  font-family: PingFangSC-Regular;
  font-size: 30px;
  color: #666666;
  text-align: right;
}

.right-arrow {
  /* px2wx:change next */
  width: 32px;
  height: 32px;
  margin-left: 8px;
}

</style>
